import { useRef, useState } from 'react'
import * as React from 'react'

import { HTMLInputEvent, SetState, AlmanacFile as File } from 'types'
import Styles from './RenameInput.module.scss'
import { stopPropagation } from 'utils'
import { FileIcon } from 'screens/Finder/components/FileIcon/FileIcon'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface RenameInputProps {
  file: File
  isBranch?: boolean
  onRename: (file: File, newName: string) => void
  setShowRename: SetState<boolean>
  className?: string
}

export const RenameInput = ({ setShowRename, file, onRename }: RenameInputProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const inputRef = useRef<HTMLInputElement>(null)
  const currentTitle = file.title
  const [titleInput, setTitleInput] = useState(file.title)

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!inputRef.current) return

    if (e.key === 'Enter') {
      e.preventDefault()
      onRename(file, titleInput)
      setShowRename(false)
    } else if (e.key === 'Escape') {
      e.preventDefault()
      setShowRename(false)
    }
  }

  const handleBlur = () => {
    if (inputRef.current?.value !== currentTitle) {
      onRename(file, titleInput)
    }

    setShowRename(false)
  }

  return (
    <div className={Styles.inputWrapper}>
      <FileIcon file={file} className={Styles.icon} size={isSystemRedesignEnabled ? 'sm' : 'md'} />
      <div onClick={stopPropagation}>
        <input
          autoFocus
          id={file.id}
          ref={inputRef}
          value={titleInput}
          onChange={(e: HTMLInputEvent) => setTitleInput(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
        />
      </div>
    </div>
  )
}
